import { useEffect, useState } from 'react';
import http from '../services/http';
import { endPoints } from '../utils/constanst';

const useCallApi = catalog => {

    const [data, setData] = useState([]);
    const [loading, setLoading] = useState(true);

    const isURL =  typeof(catalog) === 'string';

    const fetchData = async catalogName => {

        const data = await http(`${endPoints.catalog}${catalogName}`).get();

        updateData(data);

    };

    const updateData =  data => {

        setData(data);
        setLoading(false);

    }

    useEffect(() => {
       
        isURL ? fetchData(catalog) : updateData(catalog);

    }, [catalog, isURL]);

    return {
        data,
        loading,
    }
}

export default useCallApi;
